import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Switch } from 'react-router-dom'

import EventRoute from './EventRoute'
import Dashboard from './pages/Dashboard'
import Register from './pages/Register'
import Check from './pages/Check'
import Checkpoint from './pages/Checkpoint'
import Stream from './pages/Stream'
import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <EventRoute path="/:eventId/dashboard" component={Dashboard} />
      <EventRoute path="/:eventId/register" component={Register} />
      <EventRoute path="/:eventId/check" component={Check} />
      <EventRoute path="/:eventId/checkpoint" component={Checkpoint} />
      <EventRoute path="/:eventId/stream" component={Stream} />
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js